import axios from 'axios'

function sinavOlusturveyaOlaniGetir (token, sinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/createOrLoadAnalyze', {
        token: token,
        sinavid: sinavid
      })
      .then((response) => {
        if (!response || response.data.err === '') {
          resolve({ err: null, cozulensinavid: response.data.result.cozulenDenemeId, cozulenSinav: response.data.result.cozulenSinav, analizsinavi: response.data.result.analizsinavi, analizSorulari: response.data.result.analizSorulari, analizCevaplari: response.data.result.analizCevaplari })
        } else {
          resolve({ err: null, cozulensinavid: -1 })
        }
      }).catch(e => { console.log(e); reject(e.message) })
  })
}

function checkUserRight (token, sinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/getIsUserHaveEydsMembership', {
        token: token,
        sinavid: sinavid
      })
      .then((response) => {
        if ((sinavid < 0 || (response && response.data.result !== true))) {
          // this.$router.replace('SatinAl')
          resolve(false)
        } else {
          resolve(true)
        }
      })
  })
}

function startNewQuiz (token, sinavid, cozulensinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/postUserStartEydsQuiz', {
        token: token,
        sinavid: sinavid,
        cozulensinavid: cozulensinavid
      })
      .then((response) => {
        if (!response || response.data.err === null) {
          resolve({
            err: null,
            deneme: response.data.result.deneme,
            sinav: response.data.result.sinav,
            sorular: response.data.result.sorular,
            cevaplar: response.data.result.cevaplar,
            kalandakika: response.data.result.kalandakika
          })
          //  this.startQuiz_ACTION()
        } else {
          reject(response.data.err)
          // console.log(`Bir hata ile karşılaşıldı : ${response.data.err}`)
          // this.hata = `Bir hata ile karşılaşıldı : ${response.data.err}`
        }
      }).catch(e => reject(e.message))
  })
}
function sendAnswer (token, sinavid, soruid, cevap, cozulensinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/postUserAnalizAnswer', {
        token: token,
        analizid: sinavid,
        cozulenAnalizId: cozulensinavid,
        soruid: soruid,
        cevap: cevap
      })
      .then((response) => {
        if (!response || response.data.err === null) {
          resolve({
            err: null,
            cevap: response.data.result
          })
          //  this.startQuiz_ACTION()
        } else {
          reject(response.data.err)
          // console.log(`Bir hata ile karşılaşıldı : ${response.data.err}`)
          // this.hata = `Bir hata ile karşılaşıldı : ${response.data.err}`
        }
      }).catch(e => reject(e.message))
  })
}
function setEndQuiz (token, cozulensinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/postSetEndAnaliz', {
        token: token,
        cozulenAnalizId: cozulensinavid
      })
      .then((response) => {
        console.log('Analiz bitirildi!')
        resolve(true)
      }).catch(e => reject(e.message))
  })
}
function postSetAddFavorites (token, cozulensinavid, soruId, eklesil, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/postSetAddFavorites', {
        token: token,
        cozulenDenemeId: cozulensinavid,
        soruId: soruId,
        eklesil: eklesil
      })
      .then((response) => {
        console.log('Soru favorilere eklendi!')
        resolve({result: true})
      }).catch(e => reject(e.message))
  })
}
function getStatics (token, cozulensinavid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/getAnalyzeStatics', {
        token: token,
        sinavid: cozulensinavid
      })
      .then((response) => {
        resolve(response.data)
      }).catch(e => reject(e.message))
  })
}
function getEnteredQuiz (token, denemeid, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/getUserEnteredQuizes', {
        token: token,
        denemeid: denemeid
      })
      .then((response) => {
        resolve(response.data)
      }).catch(e => reject(e.message))
  })
}
function postDegerlendirmeTalebi (token, cozulensinavid, hedefpuan, aciklama, ogretmen, adres) {
  return new Promise((resolve, reject) => {
    axios
      .post(adres + 'api/v5/ogrenciGeriBildirimTalebi', {
        token: token,
        cozulensinavid: cozulensinavid,
        hedefpuan: hedefpuan,
        ogretmen: ogretmen,
        aciklama: aciklama
      })
      .then((response) => {
        console.log('Değerlendirmeniz Gönderildi')
        resolve({result: true})
      }).catch(e => reject(e.message))
  })
}
export {sinavOlusturveyaOlaniGetir, startNewQuiz, checkUserRight, sendAnswer, setEndQuiz, postSetAddFavorites, getStatics, getEnteredQuiz, postDegerlendirmeTalebi}



// WEBPACK FOOTER //
// ./src/utility/ajaxMethods.js